import { ApolloClient, InMemoryCache } from '@apollo/client'
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev'
import { links } from './links'

import { IS_DEV } from '@/config/constants'

if (IS_DEV) {
  loadDevMessages()
  loadErrorMessages()
}

const client = new ApolloClient({
  link: links,
  cache: new InMemoryCache(),
})

export default client
